import React, { useState } from "react";
import { useFormik, FormikProvider, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as HERBUI from "react-bootstrap";
import { useDispatch } from "react-redux";
import { CommonAjaxPostLoginRequestUpdated, CommonAjaxPostRequestWithToken } from "../Api/CommonAjaxUtils";
import { LOGIN_API_UPDATED } from "../Api/APIURLS";
import { useHistory } from "react-router-dom";
import Sweetalert, { popover, preventCopyPaste } from "../components/Functions";
import LoginHeader from "../components/LoginHeader";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function ChangePassword() {

    const history = useHistory();
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);


    const validationSchema = Yup.object().shape({
        oldpassword: Yup.string()
            .required("Old password is required"),
        newpassword: Yup.string().nullable()
            .required("New password is required"),
        confirmpassword: Yup.string()
            .required("Confirm password is required")
            .oneOf(
                [Yup.ref("newpassword")],
                "New Password and Confirm Password not matched"
            )
    });

    const formik = useFormik({
        initialValues: {
            oldpassword: "",
            newpassword: "",
            confirmpassword: ""
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            await saveDetails(values, setSubmitting);
        }
    });

    const saveDetails = async (values, setSubmitting) => {
        const params = {
            currentPassword: values.oldpassword,
            newPassword: values.newpassword,
            confirmPassword: values.confirmpassword,
            clientId: "nidhi"
        };
        try {
            const response =
                await CommonAjaxPostRequestWithToken(
                    LOGIN_API_UPDATED + "auth/change-password",
                    params,
                    dispatch
                );

            if (response?.status === 200) {
                setErrorMessage("");
                Sweetalert(response?.data?.message, 'success').then((result) => {
                    if (result.isConfirmed) {
                        history.push('/loginPageUpdated');
                    }
                });
                // Swal.fire({
                //     title: response?.data?.message ||
                //         response?.message ||
                //         "Password changed successfully.",
                //     icon: "success",
                //     confirmButtonText: "OK"
                // }).then((result) => {
                //     if (result.isConfirmed) {
                //         history.push('/loginPageUpdated');
                //     }
                // });
            } else {
                setErrorMessage(response?.data?.errorMessage);
                dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                // Swal.fire({
                //     title: "Unable to change password",
                //     text:
                //         response?.data?.errorMessage ||
                //         response?.errorMessage ||
                //         "Please check your current password and try again.",
                //     icon: "error"
                // });
            }

        } catch (error) {

            console.error(
                "Change password error:",
                error
            );

            // Swal.fire({
            //     title: "Error",
            //     text:
            //         error?.response?.data?.message ||
            //         "Unable to change password. Please try again.",
            //     icon: "error"
            // });

        } finally {

            setSubmitting(false);

        }
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword(prev => !prev)
    }
    const toggleNewPassword = () => {
        setShowNewPassword(prev => !prev)
    }
    const toggleOldPassword = () => {
        setShowOldPassword(prev => !prev)
    }

    return (
        <>
            <LoginHeader />

            <FormikProvider value={formik}>
                <HERBUI.Form onSubmit={formik.handleSubmit} autoComplete="off" >
                    <HERBUI.Container style={{ marginTop: "80px" }}>
                        <HERBUI.Row>
                            <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
                                <div className="inner-herbpage-service-title1 ps-0">
                                    <h1>Change Password</h1>
                                </div>
                            </HERBUI.Col>
                        </HERBUI.Row>
                    </HERBUI.Container>


                    <HERBUI.Container className="outer-page-content-container" >
                        <div className="container py-5">
                            <HERBUI.Container>
                                <HERBUI.Row>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                        <HERBUI.InputGroup className="mb-4p5">
                                            <span className="label-text-style">
                                                <b>Old Password:</b>
                                                <span className="text-danger">*</span>
                                            </span>
                                            <Field
                                                name="oldpassword"
                                                id="oldpassword"
                                                type={showOldPassword ? "text" : "password"}
                                                placeholder="Enter old password"
                                                autoComplete="current-password"
                                                // minLength={8}
                                                maxLength={50}
                                                className={
                                                    formik.touched.oldpassword &&
                                                        formik.errors.oldpassword
                                                        ? "form-control is-invalid"
                                                        : "form-control"
                                                }
                                                onCopy={preventCopyPaste}
                                                onPaste={preventCopyPaste}
                                                onCut={preventCopyPaste}
                                                onDrop={preventCopyPaste}
                                            />
                                            <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                {!showOldPassword ? <FaEyeSlash onClick={toggleOldPassword} /> : <FaEye onClick={toggleOldPassword} />}
                                            </HERBUI.InputGroup.Text>
                                            <ErrorMessage name="oldpassword" component="div" className="text-error" />
                                        </HERBUI.InputGroup>
                                    </HERBUI.Col>
                                </HERBUI.Row>

                                {/* New Password */}
                                <HERBUI.Row>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} >
                                        <HERBUI.OverlayTrigger trigger="hover" placement="right" overlay={popover}>
                                            <HERBUI.InputGroup className="mb-4p5">
                                                <span className="label-text-style">
                                                    <b>New Password:</b>
                                                    <span className="text-danger">*</span>
                                                </span>

                                                <Field
                                                    name="newpassword"
                                                    id="newpassword"
                                                    type={showNewPassword ? "text" : "password"}
                                                    placeholder="Enter new password"
                                                    autoComplete="new-password"
                                                    // minLength={8}
                                                    maxLength={50}
                                                    className={
                                                        formik.touched.newpassword &&
                                                            formik.errors.newpassword
                                                            ? "form-control is-invalid"
                                                            : "form-control"
                                                    }
                                                    onCopy={preventCopyPaste}
                                                    onPaste={preventCopyPaste}
                                                    onCut={preventCopyPaste}
                                                    onDrop={preventCopyPaste}
                                                />
                                                <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                    {!showNewPassword ? <FaEyeSlash onClick={toggleNewPassword} /> : <FaEye onClick={toggleNewPassword} />}
                                                </HERBUI.InputGroup.Text>
                                                <ErrorMessage name="newpassword" component="div" className="text-error" />
                                            </HERBUI.InputGroup>
                                        </HERBUI.OverlayTrigger>
                                    </HERBUI.Col>
                                </HERBUI.Row>

                                {/* Confirm Password */}
                                <HERBUI.Row>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} >
                                        <HERBUI.OverlayTrigger trigger="hover" placement="right" overlay={popover}>
                                            <HERBUI.InputGroup className="mb-4p5">
                                                <span className="label-text-style">
                                                    <b>Confirm Password:</b>
                                                    <span className="text-danger">*</span>
                                                </span>

                                                <Field
                                                    name="confirmpassword"
                                                    id="confirmpassword"
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    placeholder="Confirm new password"
                                                    autoComplete="new-password"
                                                    // minLength={8}
                                                    maxLength={50}
                                                    className={
                                                        formik.touched.confirmpassword &&
                                                            formik.errors.confirmpassword
                                                            ? "form-control is-invalid"
                                                            : "form-control"
                                                    }
                                                    onCopy={preventCopyPaste}
                                                    onPaste={preventCopyPaste}
                                                    onCut={preventCopyPaste}
                                                    onDrop={preventCopyPaste}
                                                />
                                                <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                    {!showConfirmPassword ? <FaEyeSlash onClick={toggleConfirmPassword} /> : <FaEye onClick={toggleConfirmPassword} />}
                                                </HERBUI.InputGroup.Text>
                                                <ErrorMessage name="confirmpassword" component="div" className="text-error" />
                                            </HERBUI.InputGroup>
                                        </HERBUI.OverlayTrigger>
                                    </HERBUI.Col>
                                </HERBUI.Row>
                                {errorMessage &&
                                    <span className='text-error mb-2'>{errorMessage}</span>
                                }

                                {/* Submit */}
                                <HERBUI.Row>
                                    <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} >
                                        <div className="d-grid">
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                                disabled={formik.isSubmitting} >
                                                Change Password
                                            </button>
                                        </div>
                                    </HERBUI.Col>
                                </HERBUI.Row>
                            </HERBUI.Container>
                        </div>
                    </HERBUI.Container>
                </HERBUI.Form >
            </FormikProvider >
        </>
    );
}

export default ChangePassword;